// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectIncludedInValuationQueryResult, selectIncludedInValuationsPageLoading, selectIncludedInValuationsShowInitWaitingMessage} from '../_selectors/included-in-valuation.selectors';

export class IncludedInValuationsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectIncludedInValuationsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectIncludedInValuationsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectIncludedInValuationQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
